import { useState } from "react";
import Button2 from "../../../Button/Button2";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { RuleProvider, useRule } from "./RuleReducer";

const ChooseWhatAddAdvRuleAction = ({selectedPinToAffect, closeDialog}) => {

    console.log(selectedPinToAffect)
    const { state, dispatch } = useRule(RuleProvider);

    const [selectedType, setSelectedType] = useState(-1)
    const [showTimeDialog, setShowTimeDialog] = useState(false)
    const [timeLength, setTimeLength] = useState(0)

    const OutputStateSelected = (type) => {
        const controlType =
            type === 0 ? "ARM" :
                type === 1 ? "TEMP_ARM" :
                    type === 2 ? "DISARM" :
                        type === 3 ? "TEMP_DISARM" :
                            type === 4 ? "OPPOSE" :
                                type === 5 ? "TOGGLE" :
                                    type === 6 ? "PULSE"
                                        : "";
        setSelectedType(type)
        
        const updatedAction = {
            ...state.actionToAdd,                 
            control_type: controlType,           
            temporary_time_ms: (type === 1 || type === 3) ? timeLength * 60000 : 0
        }

        dispatch({
            type: "SET_ACTION_TO_ADD",
            payload: updatedAction
        });
    }

    const saveAction = () => {
        //callback to parent class to save?
        closeDialog();
    }

    return (
        <>
            <Dialog
                header="Fow how long?"
                visible={showTimeDialog}
                style={{ width: "40vw" }}
                onHide={() => setShowTimeDialog(false)}
            >
                <div className="flex flex-column gap-2">
                    <label htmlFor="for">For </label>
                    <InputText
                        value={timeLength}
                        onChange={(e) => setTimeLength(e.target.value)}
                    />
                    <label htmlFor="minutes"> minutes</label>
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Set length"
                        severity="success"
                        disabled={timeLength == 0}
                        onClick={() => setShowTimeDialog(false)}
                    />
                </div>
            </Dialog>

            {selectedPinToAffect && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>

                <h3 style={{ color: "#6e6e6e" }}>What will the switch do when the rule triggers?</h3>
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "20px" }}>
                    <>
                        <h3>{`${selectedPinToAffect.pinName} will`}</h3>
                        {(selectedPinToAffect.type !== "PULSE" && selectedPinToAffect.type !== "VIRTUAL_PULSE") &&
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                                <Button2
                                    style={{
                                        minWidth: "350px",
                                        minHeight: "50px",
                                        backgroundColor: selectedType === 0 ? "var(--Primary-Color)" : undefined,
                                        color: selectedType === 0 ? "white" : undefined,
                                        border: selectedType === 0 ? "2px solid lightblue" : undefined
                                    }}
                                    onClick={() => OutputStateSelected(0)}
                                >
                                    {selectedPinToAffect.actionOneOffLabel || "Arm"}
                                </Button2>

                                {/* Temp Arm BUTTON */}
                                <Button2
                                    style={{
                                        minWidth: "350px",
                                        minHeight: "50px",
                                        backgroundColor: selectedType === 1 ? "var(--Primary-Color)" : undefined,
                                        color: selectedType === 1 ? "white" : undefined,
                                        border: selectedType === 1 ? "2px solid lightblue" : undefined
                                    }}
                                    onClick={() => { OutputStateSelected(1); setShowTimeDialog(true) }}
                                >
                                    {`Temporarily ${selectedPinToAffect.actionOneOffLabel || "Arm"}`}
                                </Button2>

                                {/* DISARM BUTTON */}
                                <Button2
                                    style={{
                                        minWidth: "350px",
                                        minHeight: "50px",
                                        backgroundColor: selectedType === 2 ? "var(--Primary-Color)" : undefined,
                                        color: selectedType === 2 ? "white" : undefined,
                                        border: selectedType === 2 ? "2px solid lightblue" : undefined
                                    }}
                                    onClick={() => OutputStateSelected(2)}
                                >
                                    {selectedPinToAffect.actionOneOnLabel || "Disarm"}
                                </Button2>

                                {/* TEMP DISARM BUTTON */}
                                <Button2
                                    style={{
                                        minWidth: "350px",
                                        minHeight: "50px",
                                        backgroundColor: selectedType === 3 ? "var(--Primary-Color)" : undefined,
                                        color: selectedType === 3 ? "white" : undefined,
                                        border: selectedType === 3 ? "2px solid lightblue" : undefined
                                    }}
                                    onClick={() => { OutputStateSelected(3); setShowTimeDialog(true) }}
                                >
                                    {`Temporarily ${selectedPinToAffect.actionOneOnLabel || "Disarm"}`}
                                </Button2>

                                {/* TOGGLE BUTTON */}
                                <Button2
                                    style={{
                                        minWidth: "350px",
                                        minHeight: "50px",
                                        backgroundColor: selectedType === 5 ? "var(--Primary-Color)" : undefined,
                                        color: selectedType === 5 ? "white" : undefined,
                                        border: selectedType === 5 ? "2px solid lightblue" : undefined
                                    }}
                                    onClick={() => OutputStateSelected(5)}
                                >
                                    {`Toggle`}
                                </Button2>
                            </div>


                        }

                        {(selectedPinToAffect.type == "PULSE" || selectedPinToAffect.type == "VIRTUAL_PULSE") &&
                            //<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                            <Button2 style={{
                                minWidth: "350px",
                                minHeight: "50px",
                                backgroundColor: selectedType === 6 ? "var(--Primary-Color)" : undefined,
                                color: selectedType === 6 ? "white" : undefined,
                                border: selectedType === 6 ? "2px solid lightblue" : undefined
                            }}
                                onClick={() => OutputStateSelected(6)}
                            >
                                {`Temporarily ${selectedPinToAffect.actionOneOnLabel}`}
                            </Button2>
                            //</div>
                        }

                        <Button
                            label="Add action"
                            rounded
                            icon="pi pi-check-circle"
                            severity="success"
                            disabled={selectedType == -1}
                            onClick={() => saveAction()}
                    />
                    </>


                </ul >
            </div> }
        </>
    )
}

export default ChooseWhatAddAdvRuleAction;